import { useEffect } from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { getIdentity } from "@/features/ui/helpers/identity-helpers";
import {
  syncAnalyticsIdentity,
  trackPageView,
} from "@/shared/analytics/analytics";

/**
 * 라우트 변경마다 신원을 동기화하고 페이지뷰를 기록한다.
 * AppLayout 에서 호출한다 — 모든 /:locale? 라우트(랜딩·패스픽 랜딩·auth·로그인 영역)가
 * 통과하는 유일한 컴포넌트다.
 *
 * 위치에 키를 걸어도 신원 변화를 놓치지 않는다: 신원은 쿠키 파생이라 반응형이 아니지만,
 * 신원을 바꾸는 모든 전이가 내비게이션이다 — 로그인, 로그아웃, 가입 승인 대기 리다이렉트,
 * 401 시 endSession(). syncAnalyticsIdentity 가 스냅샷을 비교하므로 매번 재실행해도 공짜다.
 */
export default function useAnalytics(): void {
  const location = useLocation();
  const { locale } = useParams();

  useEffect(() => {
    // useIdentity() 를 쓰지 않는다. 그 훅은 id 만 보고 메모이즈해서 같은 사용자의 회사
    // 전환 시 company 가 낡고, 내부에서 navigate 부수효과까지 돈다. 여기서는 쿠키를
    // 직접 읽으면 되므로 getIdentity() 가 맞다. 나중에 useIdentity() 로 "단순화" 하지 말 것.
    const context = syncAnalyticsIdentity(getIdentity());

    // push 는 trackPageView 가 한 프레임 미룬다 (Helmet 의 title 확정 대기).
    trackPageView({
      path: location.pathname,
      locale: locale ?? "en",
      ...context,
    });
  }, [location.pathname, locale]);
}
